module.exports = __webpack_public_path__ + "static/media/me-work.8cb6939c.png";